/**
 * Order types for RMC Two-Panel Bulk order editing layout
 */

import {FieldsForm} from '@hconnect/tuc-processes/fields/types'
import {QuantitySelection} from '@hconnect/tuc-processes/fields/quantity/types'

/**
 * Status of an RMC order
 */
export enum RmcOrderStatus {
  DRAFT = 'DRAFT',
  READY = 'READY',
  INVALID = 'INVALID',
  PLACING = 'PLACING',
  PLACED = 'PLACED',
  FAILED = 'FAILED'
}

/**
 * Individual RMC order for the two-panel layout
 */
export interface RmcOrder {
  id: string
  status: RmcOrderStatus
  createdAt: Date
  updatedAt: Date

  // Original form data for editing
  formData: FieldsForm

  // Indicates if the selected time slot requires dispatch approval
  requiresDispatchApproval?: boolean
}

export interface RmcOrderUpdateOptions {
  requiresDispatchApproval?: boolean
  isValid?: boolean
}

/**
 * Order edit state for the two-panel layout
 */
export interface RmcBulkOrderEditState {
  orders: RmcOrder[]
  selectedOrderId: string | null
  isPlacingOrders: boolean
  placementError: string | null
  lastPlacedOrderIds: string[]
  errors: Record<string, string>
  hasDateResets: boolean // Tracks if any persisted orders had their dates reset
  placementResult: RmcOrderPlacementResult | null // Stores the last placement result with requestIds
}

/**
 * Order placement result
 */
export interface RmcOrderPlacementResult {
  success: boolean
  placedOrderIds: string[]
  failedOrderIds: string[]
  errors: Record<string, string>
  requestIds: Record<string, string> // Maps orderId to requestId for successful orders
}

export interface RmcOrderRequestSummary {
  requestId: string
  material: string
  quantity: QuantitySelection
  deliveryDate: string
  poNumber?: string
}

export interface RmcOrderStatusNavigationState {
  rmcOrderRequests?: RmcOrderRequestSummary[]
}
